import React from 'react';
import styles from './ProposalCheckbox.module.css';

/**
 * Bloc Puck — Checkboxes en lecture seule issues du proposal.
 * Non interactif (pointer-events: none).
 * Affiche la question et les options avec leur état coché/non coché.
 */
const ProposalCheckbox = ({
  id,
  question = '',
  options = [],
  checkboxStyleId = null,
  checkboxStyles = [],
}) => {
  if (!question && options.length === 0) return null;

  const styleDef = Array.isArray(checkboxStyles)
    ? checkboxStyles.find((s) => String(s?.id) === String(checkboxStyleId))
    : null;
  const textColor = styleDef?.fontColor?.style || null;
  const fontFamily = styleDef?.fontFamily || null;
  const fontSize = Number(styleDef?.fontSize || 14);
  const rowGap = Number(styleDef?.rowGap || 6);
  const columnGap = Number(styleDef?.columnGap || 10);
  const boxColor = styleDef?.borders?.color?.style || '#aaa';
  const checkColor = styleDef?.check?.color?.style || '#02509D';
  const labelColor = styleDef?.color?.style || textColor;
  const boxStyle = styleDef?.styleBox || 'validate_checkbox';
  const checkStyle = boxStyle === 'fill_checkbox' ? 'fill' : 'outline';
  const borderRadius = Number(styleDef?.borders?.radius ?? 3);
  const checkedBackground = checkStyle === 'fill' ? checkColor : (styleDef?.box?.backgroundColor?.style || '#fff');
  const checkedBorderColor = checkColor;
  const boxWidth = Number(styleDef?.box?.width || 18);
  const boxHeight = Number(styleDef?.box?.height || 18);
  const checkWidth = Number(styleDef?.check?.width || 10);
  const checkHeight = Number(styleDef?.check?.height || 10);
  const direction = Number(styleDef?.disposition) === 1 ? 'row' : 'column';

  return (
    <div id={id} className={styles.wrapper} style={{ color: textColor || undefined, fontFamily: fontFamily ? `${fontFamily}, sans-serif` : undefined }}>
      {question && <p className={styles.question} style={{ fontSize: `${fontSize}px` }}>{question}</p>}
      <ul className={styles.optionList} style={{ gap: `${rowGap}px`, flexDirection: direction }}>
        {options.map((opt, idx) => (
          <li key={idx} className={styles.option} style={{ columnGap: `${columnGap}px`, fontSize: `${fontSize}px`, color: labelColor || undefined }}>
            <span
              className={`${styles.checkbox} ${opt.checked ? styles.checked : ''}`}
              style={{
                borderRadius,
                borderColor: opt.checked ? checkedBorderColor : boxColor,
                backgroundColor: opt.checked ? checkedBackground : '#fff',
                width: `${boxWidth}px`,
                height: `${boxHeight}px`,
                minWidth: `${boxWidth}px`,
              }}
            >
              {opt.checked && (
                <svg
                  viewBox="0 0 12 12"
                  className={styles.checkIcon}
                  aria-hidden="true"
                  style={{ width: `${checkWidth}px`, height: `${checkHeight}px` }}
                >
                  <polyline
                    points="1.5,6 4.5,9.5 10.5,2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    style={{ stroke: checkStyle === 'fill' ? '#fff' : checkColor }}
                  />
                </svg>
              )}
            </span>
            <span className={styles.label}>{opt.label}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ProposalCheckbox;
